import { Component, OnInit } from '@angular/core';
import { WizardService } from 'app/main/wizard-cgo/services/wizard.service';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import {TranslateLoader, TranslateModule, TranslateService} from "@ngx-translate/core";
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';
import { fuseAnimations } from '@fuse/animations';
import { ResultadosService } from '../resultados.service';
import { lang_resultados } from 'app/idiomas/i18n/resultados/resultados.lang';
import { lang_wizard } from 'app/idiomas/i18n/wizard/wizard.lang';
@Component({
  selector: 'app-go-flow',
  templateUrl: './go-flow.component.html',
  styleUrls: ['./go-flow.component.scss'],
  animations : fuseAnimations
})
export class GoFlowComponent implements OnInit {
funciones: any[]= [];
tituloResultado:any;
tituloResultado2:any;
tipoSeleccionado:any;
productosAsignados: any[]  =[];
nivelUsuario: number;
resultElegido:boolean=false;
cargando:boolean;
  constructor(
      private wizardService: WizardService,
      private _fuseTranslationLoaderService: FuseTranslationLoaderService,
      private translateSrv: TranslateService,
      private _fuseSidebarService: FuseSidebarService,
      private servTableau: ResultadosService,
  ) {
    this.funciones= [
      {
        id      : 'GOFLOW',
        slug    : 'goflow',
        category: 'CGO',
        icon : 'bubble_chart',
        imagen: 'res-cert',
        tipo: 'goFlow',
        visible:false,
      },
    ];
    lang_wizard.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });

    lang_resultados.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
   }

  ngOnInit(): void {
    this.nivelUsuario = this.servTableau.getNivel();
    this.obtieneProductosV2();
  }


  obtieneProductosV2(){
    let productGoFlow:any[]=[];
    this.wizardService.getProductos().subscribe( (respuesta: any) => {
      console.log('respuesta',respuesta);
      respuesta.productosResultadosGoFlow.forEach(productoGoFlow => {
        if (productoGoFlow.idProducto==70) {
          productGoFlow.push(productoGoFlow);
        }
      });
      console.log('productGoFlow',productGoFlow);
      if (productGoFlow.length>0) {this.funciones[0].visible=true;}
      console.log('this.funciones',this.funciones);



    });

  }

  obtieneProductos(tipoProducto:string){
    this.cargando=true;
    this.resultElegido=true;
    this.tipoSeleccionado= tipoProducto;
    console.log("Tipo de producto");
    console.log(this.tipoSeleccionado);
    switch(this.tipoSeleccionado){
      case "goFlow":
      let tituloResult1 = 'Resultados Go Flow';
      //this.translateSrv.get(tituloResult1).subscribe((res: string) => { tituloResult1 = res; });
      this.tituloResultado=tituloResult1;

      break;
    }
    console.log("Titulo "+this.tituloResultado);
    console.log(this.servTableau);
    console.log(this.servTableau.getNivel());

    switch(this.servTableau.getNivel()){

      case 1: case 5: case 4: case 10:
      this.wizardService.getProductos().subscribe( (respuesta: any) => {
        console.log(respuesta);
        let prods: any;
        let prodspar1: any;
        let prodsRC:any;
        let url: string;
        let nombre: string;
        let tokenEncuesta: string;

        switch(tipoProducto){
          case 'goFlow':
          if(respuesta.productosResultadosGoFlow.length > 0){
            let goFlow:any[]=[];
            respuesta.productosResultadosGoFlow.forEach(goFlo => {
              if (goFlo.idProducto==70) {
                console.log("encontro ");
                goFlow.push(goFlo);
              }

            });
            prods = goFlow;
          }
            url = 'goFlow'; nombre = 'GOFLOW';
          break;
        }
        prods = this.ordenaDescendente(prods, tipoProducto);

        this.colocaProductos(nombre,url,prods,prodsRC);
      });
      break;
    }
  }

  ordenaDescendente(datos:any, tipo:string){
    switch(tipo){
      case 'goFlow':
        datos.sort( (a,b) => { if(a.fecha < b.fecha){ return 1; } else{ return -1; } });
      break;
    }
    return datos;
  }

  colocaProductos(producto:string, url:string, datos:any, prodsRC:any){
    // console.log(datos);
    console.log("producto:",producto);
    console.log("url:",url);
    console.log("datos:",datos);
    console.log("prodsRC:",prodsRC);

    //agrega un producto de tipo resultados heredados
    console.log("Colocar productos");

      datos.forEach( (elem) => {
        console.log(elem);
        let fecha:number;
        let idProducto:string;
        let versionProducto:number;
        let numeroPulse:number;
        let completo: number;
        let tagStatus: string;
        let tableauVersion: string;
        let activo = true;
        let tokenEncuesta: string;
        let fechaCierreEncuesta: string;
        switch(producto){
          case 'GOFLOW':
            if (elem.idProducto==70) {
          console.log('ENTRO ESTE PRODUCTO');
          console.log('elem',elem);

            fecha = elem.fecha;
            completo = 2;
          }



            this.productosAsignados.push(
              {
                category: 'CGO',
                length  : 30,
                title   : 'WIZARD.'+producto+'.TITULO',
                date : fecha,
                url : url,
                productoID : idProducto,
                start : 'WIZARD.LANDING.ENTRAR',
                completo,
                idProducto: elem.idProducto,

              }
            );

            // }
          break;
          }


      });
      console.log("productosAsignados:::: ",this.productosAsignados);
    this.cargando = false;
    // this.cargandoNuevos = false;
    this.productosAsignados.sort( (a,b) => { if(a.date < b.date){ return 1; } else{ return -1; } });
    console.log("asignados.",this.productosAsignados);

  }



regresar(){
  this.resultElegido=false;
}

}
